import { render } from "./HdbtEventView.vue?vue&type=template&id=23bd5b83&scoped=true"
import script from "./HdbtEventView.vue?vue&type=script&lang=js"
export * from "./HdbtEventView.vue?vue&type=script&lang=js"

import "./HdbtEventView.vue?vue&type=style&index=0&id=23bd5b83&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23bd5b83"]])

export default __exports__